import {createReducer} from '@reduxjs/toolkit'
import {SET_BASE_ENVIRONMENT_OLD, setBaseEnvironment, setFormFactor} from '../actions/environment'
import {EnvironmentConfig} from '../types/state'

const defaultState: EnvironmentConfig = {} as EnvironmentConfig

export const environment = createReducer(defaultState, builder =>
  builder
    .addCase(setBaseEnvironment.fulfilled, (state, action) => ({...state, ...action.payload}))
    .addCase(setFormFactor, (state, action) => ({...state, mobile: action.payload === 'Mobile'}))
    .addMatcher(
      action => action.type === SET_BASE_ENVIRONMENT_OLD,
      (state, action) => ({...state, ...action.payload}),
    ),
)
